module.exports = __webpack_public_path__ + "img/bn_cover.f21b1c74.jpg";